import { yupResolver } from "@hookform/resolvers/yup";
import { getToday } from "api/constants";
import { GetDownloadCategories, PostDownloads, UploadFile } from "api/endpoints";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import FilePreviewer from "components/ckeditor/MEIFilePreview";
import MEILoader from "components/ckeditor/MEILoader";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { Card, FloatingLabel, } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FiUpload } from "react-icons/fi";
import { toast } from "react-toastify";
import * as yup from "yup";
// import ProductBasicInfo from "./add-product-tab/ProductBasicInfo";

const schema = yup
  .object({
    fTitle: yup.string().required("Title is required."),
    fDescription: yup.string().required("Description is required."),
    // fFile: yup.string().required("File is required."),
    fFile: yup.string(),
    fCateg: yup.number().required("Please select valid category"),
    fStatus: yup.string().required("Status is required."),
    fDate: yup.string().required("Date is required."),
    eLink: yup.string().required("Apply Now url is required."),
    fOrder: yup.number().required("Sequence is required.").min(0, 'Please enter valid number'),
  })
  .required();

const initialForm = {
  fTitle: '',
  fDescription: '',
  fFile: '',
  fCateg: 0,
  fStatus: 'true',
  fDate: getToday(),
  eLink: '',
  fOrder: '0',

};

const ProductBasicInfo = ({ setLoading }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    watch
  } = useFormContext();


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {


      const allowedTypes = [
        'image/jpeg', // .jpg, .jpeg
        'image/gif',  // .gif
        'image/png',  // .png
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
        'application/zip', // .zip
        'application/x-zip-compressed', // .zip
        'application/zip-compressed', // .zip
        'application/pdf', // .pdf
        'text/plain', // .txt
        'text/csv', // .csv
        'application/vnd.ms-excel', // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'video/mp4' // .mp4
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid File Format', {
          theme: "colored",
        });
        e.target.value = '';
        return
      }
      else {
        setLoading(true)
        const formData = new FormData();
        formData.append('file', file);

        UploadFile(formData).then(res => {
          // toast.success('File Uploaded Successfully!', {
          //   theme: "colored",
          // });
          setValue('fFile', res?.data)
          e.target.value = '';
          setLoading(false)

        }).catch(err => {
          setLoading(false)
          toast.error('File Uploading Failed', {
            theme: "colored",
          });
        });

      }

    }
  };

  return (
    <Row className="gx-2 gy-3">

      <Col md="12">
        <Form.Group>
          {/* <Form.Label>First name:</Form.Label> */}
          <FloatingLabel
            controlId="floatingInput"
            label="Title"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fTitle}
              {...register("fTitle")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fTitle?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



      <Col md="12">

        <Form.Label>Description</Form.Label>
        <MEICKEditor
          value={getValues('fDescription')}
          onchangeValue={(vl) => {
            setValue('fDescription', vl)
          }} />

      </Col>

      {/* <Col md="12">
        <Form.Group>
          <FloatingLabel
            controlId="floatingInput"
            label="Description"
            className=""
          >
            <Form.Control
              as="textarea"
              rows={4}
              placeholder=""
              isInvalid={!!errors.fDescription}

              style={{ height: '120px' }}
              {...register("fDescription")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fDescription?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col> */}



      <Col md="4" style={{ position: 'relative' }}>
        {/* <Form.Group>
          <FloatingLabel
            controlId="floatingInput"
            label="Download File"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fFile}
              // style={{height: '80px'}}
              {...register("fFile")}
              onKeyDown={e => e.preventDefault()}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fFile?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group> */}





        <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
          Download File
        </Form.Label>
        <FilePreviewer accept=" .jpg, .jpeg, .gif, .png, .doc, .docx, .zip, .pdf, .txt, .csv, .xls, .xlsx, .mp4" furl={watch('fFile')} />


        <Form.Label htmlFor={`file-upload-jb`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
          <FiUpload className="me-1" size={40} />
        </Form.Label>
        <Form.Control
          id={`file-upload-jb`}
          type="file"
          style={{ width: '120px' }}
          onChange={(e) => handleFileChange(e)}
          className="d-none"
          accept=" .jpg, .jpeg, .gif, .png, .doc, .docx, .zip, .pdf, .txt, .csv, .xls, .xlsx, .mp4"
        />

      </Col>




      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Last Date Apply" className="">
            <Form.Control
              type="date"
              placeholder=""
              isInvalid={!!errors.fDate}
              {...register("fDate")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fDate?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Apply Now URL" className="">
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.eLink}
              {...register("eLink")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.eLink?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>

      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Status" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.fStatus}
              {...register("fStatus")}
            >
              <option value="true">Published</option>
              <option value="false">Un-Published</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fStatus?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>





      <Col md="4">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Sequence Order" className="">
            <Form.Control
              type="number"
              placeholder=""
              isInvalid={!!errors.fOrder}
              {...register("fOrder")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fOrder?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



    </Row>
  );
};


const AddJob = ({ handleDiscard, editData }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset } = methods;

  // const [categories, setCategories] = useState([]);
  // const fetchCategories = () => {
  //   GetDownloadCategories().then(res => {
  //     setCategories(res?.data?.data?.map(cat => ({id: cat.id, name: cat.name})))
  //   }).catch();
  // }
  // useEffect(() => {
  //   fetchCategories();
  // }, [])

  useEffect(() => {
    if (editData?.id) {

      const esdesc = JSON.parse(editData.description);
      reset({
        fTitle: editData.title,
        fDescription: esdesc.description,
        fFile: editData.fileName,
        fCateg: editData.categoryId,
        fStatus: editData.status.toString(),
        fDate: editData.fileDate.slice(0, 10),
        eLink: esdesc.applyLink,
        fOrder: editData.order,
      })
    }
    else {
      reset(initialForm);
    }

  }, [editData])

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    console.log(data);
    // // ------- Get all object keys form data and set empty values to reset ------------
    // const keys = Object.keys(data);
    // for (const key of keys) {
    //   submittedValues[key] = "";
    // }

    setLoading(true)
    const edesc = JSON.stringify({
      description: data.fDescription,
      applyLink: data.eLink,

    });
    const finalData = {
      id: editData?.id ? editData?.id : 0,
      title: data.fTitle,
      description: edesc,
      fileName: data.fFile,
      fileDate: data.fDate,
      categoryId: data.fCateg,
      status: data.fStatus === "true",
      order: data.fOrder,
      types: 'JOBS'
    }

    PostDownloads(finalData).then(res => {

      toast.success('Data Saved Successfully', {
        theme: "colored",
      });
      setLoading(false)
      reset(initialForm)
      handleDiscard(true);

    }).catch(err => {

      toast.error('Data Saving Failed', {
        theme: "colored",
      });
      setLoading(false)
      console.log(err, 'PostDownloadsError')

    });


  };

  const handleDiscardPre = () => {
    reset(initialForm)
    handleDiscard();
  }

  return (
    <>

      <MEILoader showLoader={loading} />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">

            <Col lg={12}>
              <ProductBasicInfo setLoading={setLoading} />
            </Col>

            <Col xs={12}>
              <Row className="flex-between-center mt-3">
                <Col md>
                  {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={handleDiscardPre}
                  >
                    Discard
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {editData?.id ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            </Col>

          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddJob;
